// DayEditModal.jsx

import React, { useState, useEffect } from 'react';
import './DayEditModal.css'; // optional CSS

function DayEditModal({
  dateStr,
  existingOverrides,
  globalStart,
  globalEnd,
  globalBreaks,
  onClose,
  onSave
}) {
  const [start, setStart] = useState(existingOverrides?.startTime || globalStart);
  const [end,   setEnd]   = useState(existingOverrides?.endTime   || globalEnd);
  const [breaks, setBreaks] = useState(
    existingOverrides?.breakTimes?.length > 0
      ? existingOverrides.breakTimes
      : globalBreaks || []
  );

  // For new break
  const [newBreakStart, setNewBreakStart] = useState('');
  const [newBreakEnd, setNewBreakEnd]     = useState('');

  function handleAddBreak() {
    if (!newBreakStart || !newBreakEnd) return;
    setBreaks(prev => [...prev, { start: newBreakStart, end: newBreakEnd }]);
    setNewBreakStart('');
    setNewBreakEnd('');
  }

  function handleRemoveBreak(i) {
    setBreaks(prev => {
      const copy = [...prev];
      copy.splice(i, 1);
      return copy;
    });
  }

  function handleSaveClick() {
    onSave(dateStr, {
      startTime: start,
      endTime:   end,
      breakTimes: breaks
    });
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Edit Day: {dateStr}</h3>
        <div className="field-group">
          <label>Start Time:</label>
          <input type="time" value={start} onChange={(e) => setStart(e.target.value)} />
        </div>
        <div className="field-group">
          <label>End Time:</label>
          <input type="time" value={end} onChange={(e) => setEnd(e.target.value)} />
        </div>
        <div style={{ marginTop: '10px' }}>
          <label>Breaks:</label>
          <div style={{ margin: '5px 0' }}>
            <input type="time" value={newBreakStart} onChange={(e) => setNewBreakStart(e.target.value)} />
            <input type="time" value={newBreakEnd}   onChange={(e) => setNewBreakEnd(e.target.value)} />
            <button onClick={handleAddBreak}>Add Break</button>
          </div>
          {breaks.map((b, i) => (
            <div key={i} style={{ marginBottom:'5px' }}>
              {b?.start} - {b?.end}
              <button style={{ marginLeft: '8px' }} onClick={() => handleRemoveBreak(i)}>Remove</button>
            </div>
          ))}
        </div>

        <div style={{ marginTop:'20px' }}>
          <button onClick={handleSaveClick}>Save</button>
          <button onClick={onClose} style={{ marginLeft:'10px' }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default DayEditModal;